import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent,
} from "@mui/material";
import clsx from "clsx";
import i18n from "i18n/i18n";
import { useEffect, useState } from "react";
import NewCalender from "./NewCalender";
import { useBoundStore } from "store/store";
import moment from "moment";
import KalenderSkeliton from "./KalenderSkeliton";

interface SiteData {
  [siteId: string]: {
    name: string;
    nodeid: string;
    hasarea: Array<{ area: Record<string, any> }>;
  };
}

function Wartungskalender() {
  const lang: any = useBoundStore((state) => state.lang);

  const [map, setmap] = useState<any>();
  const getNotifications = useBoundStore((state) => state.getNotifications);

  const getNotificationsByEqs = useBoundStore(
    (state) => state.getNotificationsByEqs
  );

  const loadTopology = useBoundStore((state) => state.loadTopology);
  const subscribedSites: any = useBoundStore((state) => state.subscribedSites);
  const [poolsToDisplay, setpoolsToDisplay] = useState<Array<any>>([]);
  const [title, setTitle] = useState<string>(i18n(lang)?.alle_machine_parks);

  const [showSkeliton, setShowSkeliton] = useState(true);

  const subscribedEquipmentpools: any = useBoundStore(
    (state) => state.subscribedEquipmentpools
  );

  const subscribedEquipmentsCalender: any = useBoundStore(
    (state) => state.subscribedEquipmentsCalender
  );

  const subscribedEquipments: any = useBoundStore(
    (state) => state.subscribedEquipments
  );
  const subscribedAreas: any = useBoundStore((state) => state.subscribedAreas);

  const getAllNotifications: any = useBoundStore(
    (state) => state.getAllNotifications
  );

  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);
  const [areas, setAreas] = useState(i18n(lang).all);
  const [areaName, setAreaName] = useState(i18n(lang).all);

  const [factories, setFactories] = useState(i18n(lang).all);

  useEffect(() => {
    if (Object.keys(subscribedEquipmentsCalender).length) {
      getNotificationsByEqs(
        lang,
        Object.keys(subscribedEquipmentsCalender).map((obj: any) => {
          return subscribedEquipmentsCalender[obj].nodeid;
        })
      );
    }
  }, []);

  const handleFactoriesChange = (event: SelectChangeEvent<string>) => {
    setAreas("");
    setAreaName("");
    const selectedValue = event.target.value;

    if (selectedValue === i18n(lang).all) {
      // Set factories to an array containing all the keys
      ExtractMachinesofAllAreasFromSAE();
    } else {
      // Set factories to an array with the selected value
      ExtractMachinesofSAE(selectedValue);
    }

    setFactories(selectedValue);
  };

  const handleAreasChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event?.target?.value;

    if (selectedValue === i18n(lang).all && factories === i18n(lang).all) {
      setAreaName(i18n(lang).all);
      // Set areasNodeIds to an array containing all the nodeids
      ExtractMachinesofAllAreasFromSAE();
    } else if (
      selectedValue === i18n(lang).all &&
      factories !== i18n(lang).all
    ) {
      ExtractMachinesofAreaFromSingleSAE(factories);
    } else {
      // Set areasNodeIds to an array with the selected value
      ExtractMachinesofAreaFromSAE(event?.target?.value);
    }
    setAreas(selectedValue);

    // update area name

    {
      siteData &&
        Object.keys(siteData).map((key) => {
          const factory = siteData[key];

          factory.hasarea &&
            factory.hasarea.map((area) => {
              if (area.area.nodeid === selectedValue) {
                setAreaName(area.area.name);
              }
            });
        });
    }
  };

  const ExtractMachinesofAreaFromSingleSAE = (nodeId: string) => {
    let tempContainers: any = [];
    let i = 0;

    for (const site of Object.keys(siteData)) {
      if (siteData[site].nodeid == nodeId) {
        if (siteData[site].hasarea != undefined) {
          for (const area of siteData[site].hasarea) {
            area.area?.hasequipment?.forEach(
              (equipment: { equipment?: Record<string, any> }) => {
                if (equipment) {
                  tempContainers.push(equipment);
                }
              }
            );
            i++;
          }
        }
      }
    }

    RenderCalendar1(tempContainers);
  };

  const ExtractMachinesofSAE = (nodeId: string) => {
    // set Boolean to allow conditional UI
    let tempContainers: any = [];
    let i = 0;
    if (Object.keys(siteData).length > 0) {
      for (const site of Object.keys(siteData)) {
        if (siteData[site].nodeid == nodeId) {
          if (siteData[site].hasarea != undefined) {
            for (const area of siteData[site].hasarea) {
              area.area?.hasequipment?.forEach(
                (equipment: { equipment?: Record<string, any> }) => {
                  if (equipment) {
                    tempContainers.push(equipment);
                  }
                }
              );
              i++;
            }
          }
        }
      }
    }
    RenderCalendar1(tempContainers);
  };

  function isEmpty(obj:any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  const ExtractMachinesofAllAreasFromSAE = () => {
    let tempContainers: any = [];

    if (Object.keys(siteData).length > 0) {
      // let i = 0;
      for (const site of Object.keys(siteData)) {
        if (siteData[site].hasarea != undefined) {
          for (const area of siteData[site].hasarea) {
            area.area?.hasequipment?.forEach(
              (equipment: { equipment?: Record<string, any> }) => {
                if (equipment) {
                  tempContainers.push(equipment);
                }
              }
            );
            // i++;
          }
        }
      }
    }
    RenderCalendar1(tempContainers);
  };

  const ExtractMachinesofAreaFromSAE = (nodeId: string) => {
    // set Boolean to allow conditional UI
    let filtered_machines;

    let key = 0;

    let tempContainers: any = [];
    let areaToUpdateTitle;

    for (const site of Object.keys(siteData)) {
      if (siteData[site].hasarea != undefined) {
        for (const area of siteData[site].hasarea) {
          if (area.area.nodeid == nodeId) {
            areaToUpdateTitle = area.area;
            filtered_machines = area.area?.hasequipment;
            setTitle(areaToUpdateTitle.name); // Move the setTitle here
          }
        }
      }
    }

    filtered_machines &&
      filtered_machines.map(
        (equipment: { equipment?: Record<string, any> }) => {
          if (equipment) {
            tempContainers.push(equipment);
          }
        }
      );
    RenderCalendar1(tempContainers);
  };

  const RenderCalendar1 = (array: any) => {
    const map = {};

    let startcalendarTS = 0;
    let stopcalendarTS = 0;

    startcalendarTS = Number(
      moment().clone().startOf("month").subtract("y", 1).format("x")
    );
    stopcalendarTS = Number(
      moment()
        .clone()
        .endOf("month")
        .add("y", calenderTimeSpan - 2)
        .format("x")
    );

    array &&
      array.map((m:any, k:any) => {
        m.equipment.hasmaintenancetask &&
          m.equipment.hasmaintenancetask.map((mt:any, k:any) => {
            if (
              mt.maintenancetask.repetitioninterval !== "" &&
              mt.maintenancetask.repetitioninterval !== undefined &&
              mt.maintenancetask.repetitioninterval !== null
            ) {
              // getting all notification of that maintenance task

              let notifications:any = [];

              getAllNotifications?.length > 0 &&
              getAllNotifications?.map((n: any, k: number) => {
                  if (
                    n.notification?.hasmaintenancetask &&
                    n.notification?.hasmaintenancetask[0]?.maintenancetask
                      ?.nodeid == mt.maintenancetask.nodeid
                  ) {
                    notifications.push(n.notification);
                  }
                });

              let x = mt.maintenancetask.startingfrom;
              //array of occurance
              const arrayofOccourance = [];

              if (mt.maintenancetask.repetitioninterval !== "onetime") {
                if (
                  mt.maintenancetask.repetitioninterval === undefined ||
                  mt.maintenancetask.repetitioninterval === "" ||
                  mt.maintenancetask.repetitioninterval === null
                ) {
                  return;
                }
                while (x < stopcalendarTS) {
                  if (x >= startcalendarTS && x <= stopcalendarTS) {
                    const occrNotification = notifications.filter(
                      (notification:any, index:any) => {
                        return notification.dueuntil === x;
                      }
                    );

                    arrayofOccourance.push({
                      occMonth: moment(x).format("M"),
                      occYear: moment(x).format("YYYY"),
                      occTS: x,
                      notification: occrNotification.length
                        ? occrNotification[0]
                        : undefined,
                    });
                  }

                  // calculating next iterations

                  if (mt?.maintenancetask.repetitioninterval == "1w") {
                    x = Number(moment(x).add("weeks", "1").format("x"));
                  } else if (mt?.maintenancetask.repetitioninterval == "2w") {
                    x = Number(moment(x).add("weeks", "2").format("x"));
                  } else if (mt?.maintenancetask.repetitioninterval == "1m") {
                    x = Number(moment(x).add("M", "1").format("x"));
                  } else if (mt?.maintenancetask.repetitioninterval == "2m") {
                    x = Number(moment(x).add("M", "2").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "3m") {
                    x = Number(moment(x).add("M", "3").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "6m") {
                    x = Number(moment(x).add("M", "6").format("x"));
                  } else if (
                    mt.maintenancetask.repetitioninterval == "1y" ||
                    mt.maintenancetask.repetitioninterval == "12m"
                  ) {
                    x = Number(moment(x).add("M", "12").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "18m") {
                    x = Number(moment(x).add("M", "18").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "24m") {
                    x = Number(moment(x).add("M", "24").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "36m") {
                    x = Number(moment(x).add("M", "36").format("x"));
                  } else if (mt.maintenancetask.repetitioninterval == "48m") {
                    x = Number(moment(x).add("M", "48").format("x"));
                  }
                }
              } else {
                const occrNotification = notifications.filter(
                  (notification:any, index:any) => {
                    return notification.dueuntil === x;
                  }
                );

                arrayofOccourance.push({
                  occMonth: moment(x).format("M"),
                  occYear: moment(x).format("YYYY"),
                  occTS: x,
                  notification: occrNotification.length
                    ? occrNotification[0]
                    : undefined,
                });
              }

              const key:any = m.equipment.name;
              const model =
                m.equipment.hasequipmenttype &&
                m.equipment.hasequipmenttype[0]?.equipmenttype.model;
              const brand =
                m.equipment.hasequipmenttype &&
                m.equipment.hasequipmenttype[0]?.equipmenttype
                  .isequipmenttypeof[0]?.brand.name;

              if (!isEmpty(map) && key in map) {
                const swimLane = {
                  task: mt.maintenancetask,
                  occurance: arrayofOccourance,
                };

                const swimLaneKey:any = "swimLanes";
                const swimLaneArray = (map as any)[key][swimLaneKey];
                swimLaneArray.push(swimLane);
                (map as any)[key] = {
                  name: m.equipment.name,
                  brand: brand,
                  model: model,
                };
                (map as any)[key][swimLaneKey] = swimLaneArray;
                // }
              } else {
                //add swim lane
                const swimLane = {
                  task: mt.maintenancetask,
                  occurance: arrayofOccourance,
                };
                const swimLaneKey = "swimLanes";
                const swimLaneArray = [];
                swimLaneArray.push(swimLane);
                (map as any)[key] = {
                  name: m.equipment.name,
                  brand: brand,
                  model: model,
                };
                (map as any)[key][swimLaneKey] = swimLaneArray;
              }
            }
          });
      });
    setmap(map);
  };

  let calenderTimeSpan = 3; //in years
  useEffect(() => {
    if (getAllNotifications) {
      loadTopology(lang);
      ExtractMachinesofAllAreasFromSAE()
    }

    if (Object.keys(getAllNotifications).length) {
      setTimeout(() => {
        setShowSkeliton(false);
      }, 1500);
    }
  }, [getAllNotifications]);

  return (
    <Card className={clsx("initialCard", "maintenance_calender")}>
      {showSkeliton ? (
        <KalenderSkeliton />
      ) : (
        <>
          <div className="dashboard">
            <div className="header" style={{ padding: 0 }}>
              <div className="title">
                {i18n(lang)?.miantenance_calender_title}
              </div>
              <div
                className="dashboardTableHeader"
                style={{ paddingTop: "1%" }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ paddingRight: "24px" }}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="demo-simple-select-label">
                        {i18n(lang)?.sites}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={factories}
                        sx={{ minWidth: "180px" }}
                        label={i18n(lang)?.sites}
                        onChange={handleFactoriesChange}
                      >
                        <MenuItem value={i18n(lang).all}>
                          {i18n(lang).all}
                        </MenuItem>
                        {siteData &&
                          Object.keys(siteData).map((key: any, index) => (
                            <MenuItem value={siteData[key]?.nodeid}>
                              {siteData[key]?.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ paddingRight: "24px" }}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="demo-simple-select-label">
                        {i18n(lang)?.areas}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={areas}
                        sx={{ minWidth: "180px" }}
                        label={i18n(lang)?.areas}
                        onChange={handleAreasChange}
                      >
                        {factories === i18n(lang).all ? (
                          <MenuItem value={i18n(lang).all}>
                            {i18n(lang).all}
                          </MenuItem>
                        ) : (
                          <MenuItem value={i18n(lang).all}>
                            {i18n(lang).all}
                          </MenuItem>
                        )}
                        {siteData &&
                          Object.keys(siteData).map((key) => {
                            const factory = siteData[key];

                            if (
                              factories === i18n(lang).all ||
                              factories === factory.nodeid
                            ) {
                              return (
                                factory.hasarea &&
                                factory.hasarea.map((area) => (
                                  <MenuItem
                                    value={area?.area?.nodeid}
                                    key={area?.area?.nodeid}
                                  >
                                    {area?.area?.name}
                                  </MenuItem>
                                ))
                              );
                            }

                            return null;
                          })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ margin: "28px 0px" }}>
            <div className="generalHeading">{i18n(lang)?.machinepark}</div>
            <div className="status">
              {i18n(lang)?.area}(e):{" "}
              {areas === "Alle" || areas === "All" ? i18n(lang).all : areaName}
            </div>
          </div>

          <NewCalender map={map} />
        </>
      )}
    </Card>
  );
}

export default Wartungskalender;
